<template>
  <div style="background: red">
    <el-dialog
      width="80%"
      title="样式模版"
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <!-- @close="$emit('update:visible', false)" -->
      <div class="box">
        <!-- 展示图层 -->
        <div class="set-specification-box">
          <div class="set-specification" @click="selectedLayer('底图')">
            <!-- 底图 -->
            <img
              ref="baseImg"
              :src="actImgStratum.Base.url"
              class="big-base-img"
              :style="`z-index: ${actImgStratum.Base.zIndex};${
                actImgStratum.Base.border ? 'border:1px solid red;' : ''
              }`"
            />
            <!-- 顶图【占位图】  -->
            <div
              ref="dragImgBox"
              @mousedown="handleMouseDown($event, $refs.dragImgBox)"
              class="drag-dot-box"
              :style="`
                width: ${imgWidth}px;
                top:${position.y}px;
                left:${position.x}px;
                z-index: ${actImgStratum.Top.zIndex};
                ${actImgStratum.Top.border ? 'border:1px solid red;' : ''}
              `"
            >
              <!-- 拖动点 -->
              <div
                ref="dragDot"
                class="drag-dot"
                @mousedown.stop="dragDot($event)"
              />
              <img
                ref="dragImg"
                v-if="actImgStratum.Top.url !== ''"
                :style="`max-width: 100%;width: ${imgWidth}px;
                `"
                :src="actImgStratum.Top.url"
                @click.stop="selectedLayer('顶图')"
              />
            </div>
          </div>
        </div>
        <!-- 4个按钮 :before-upload="beforeAvatarUpload"-->
        <div class="operation-btn">
          <el-upload
            :action="uploadurl"
            :data="data_"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
          >
            <el-button style="margin-right: 10px"> 上传底图 </el-button>
          </el-upload>
          <el-button @click="hierarchy('移至顶层')"> 移至顶层 </el-button>
          <!-- <el-button @click="getDing('获取定位信息')"> 获取定位信息 </el-button> -->
          <el-button @click="hierarchy('移至底层')" style="margin-right: 10px">
            移至底层
          </el-button>
          <el-upload
            :action="uploadurl"
            :data="data_"
            :show-file-list="false"
            :on-success="_handleAvatarSuccess"
          >
            <el-button>上传内容</el-button>
          </el-upload>
        </div>
        <!-- 底部列表 :before-upload="beforeAvatarUpload"-->
        <!-- <div class="base-map">
          <div class="base-map-box">
            <div class="base-map-item">
              <el-upload
                class="avatar-uploader"
                :action="uploadurl"
                :data="data_"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
              >
                <div class="Istyle">
                  <i class="el-icon-plus" />
                </div>
              </el-upload>
            </div>
            <div
              class="base-map-item"
              v-for="item in baseBgList"
              :key="item"
              @click="setSpecification(item)"
            >
              <img :src="item" />
            </div>
          </div>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close()">取 消</el-button>
        <el-button type="primary" @click="subData('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import api from "@/api.js";
// import topImg from "./topImg.vue";

export default {
  data() {
    return {
      dotX: "",
      dotY: "",
      imgWidth: "",
      imgHeight: "",
      oldWidth: "",
      oldHeight: "",
      dragDotDragging: false,
      startX: 0,
      startY: 0,
      position: {
        x: 0,
        y: 0,
      },
      selectedLayerType: "", //选中图层类型【底部/顶部】
      actImgStratum: {
        //当前选中的图
        Base: {
          //底图
          url: "",
          zIndex: 2,
          border: false,
        },
        Top: {
          //顶图
          url: "",
          zIndex: 1,
          border: false,
        },
      },
      uploadurl: api.uploadTokenImg,
      baseBgList: [],
      dialogVisible: false,
      data_: { token: sessionStorage.getItem("token") },
    };
  },
  // components: {
  //   topImg,
  // },
  methods: {
    setMakeData(makeData) {
      this.$nextTick(() => {
        // this.$refs.baseImg.width = this.makeData.baseImg.width;
        // this.$refs.baseImg.height = this.makeData.baseImg.height;
        this.actImgStratum.Base.url = makeData.baseImg.imgUrl;
        this.imgWidth = makeData.topImg.width;
        this.imgHeight = makeData.topImg.height;
        this.actImgStratum.Top.url = makeData.topImg.imgUrl;
        this.position.x = makeData.topImg.x;
        this.position.y = makeData.topImg.y;
      });
    },
    subData() {
      this.$emit("subData", {
        //底图
        baseImg: {
          width: this.$refs.baseImg.width, //宽
          height: this.$refs.baseImg.height, //高
          imgUrl: this.actImgStratum.Base.url, //底图地址
        },
        //示意图
        topImg: {
          width: this.$refs.dragImg.width, //宽
          height: this.$refs.dragImg.height, //高
          imgUrl: this.actImgStratum.Top.url, //示意图地址
          ...this.position, //定位
        },
      });
    },
    // 获取定位信息
    getDing() {
      console.log(this.$refs.baseImg.width, this.$refs.baseImg.height, 8888888);
      console.log(this.position, this.imgWidth, this.imgHeight, 99999999);
    },
    dragDot(event) {
      this.imgWidth = this.$refs.dragImg.width;
      // this.imgHeight = this.$refs.dragImg.height;
      // console.log(
      //   event,
      //   this.imgWidth,
      //   this.imgHeight,
      //   this.$refs.dragImg,
      //   777777
      // );
      // 阻止默认行为
      event.preventDefault();
      // 记录拖拽开始时的鼠标位置和图片位置
      this.dragDotDragging = true;
      this.dotX = event.clientX;
      this.dotY = event.clientY;
      this.oldWidth = this.imgWidth;
      this.oldHeight = this.imgHeight;
      // 添加全局的mousemove和mouseup监听器
      document.addEventListener("mousemove", this.dragDotMouseMove);
      document.addEventListener("mouseup", this.dragDotMouseUp);
    },
    // 监听拖拽移动【建立拖拽监听，计算xy】
    dragDotMouseMove(event) {
      console.log(event, 10000000000);
      if (!this.dragDotDragging) return;
      this.imgWidth = this.oldWidth * 1 + event.clientX * 1 - this.dotX * 1;
      this.imgHeight = this.$refs.dragImg.height;
    },
    // 停止拖拽，放开鼠标【清除全局监听状态】
    dragDotMouseUp() {
      console.log(
        this.imgWidth,
        this.imgHeight,
        this.$refs.dragImg.width,
        this.$refs.dragImg.height,
        30000
      );
      // 移除全局的mousemove和mouseup监听器
      document.removeEventListener("mousemove", this.dragDotMouseMove);
      document.removeEventListener("mouseup", this.dragDotMouseUp);
      // 重置拖拽状态
      this.dragDotDragging = false;
    },
    // ================================================================================
    handleMouseDown(event, img) {
      // 阻止默认行为
      event.preventDefault();
      // 记录拖拽开始时的鼠标位置和图片位置
      this.dragging = true;
      this.startX = event.clientX - img.offsetLeft;
      this.startY = event.clientY - img.offsetTop;
      // 添加全局的mousemove和mouseup监听器
      document.addEventListener("mousemove", this.handleMouseMove);
      document.addEventListener("mouseup", this.handleMouseUp);
    },
    // 监听拖拽移动【建立拖拽监听，计算xy】
    handleMouseMove(event) {
      if (!this.dragging) return;
      // 计算新的图片位置
      this.position.x = event.clientX - this.startX;
      this.position.y = event.clientY - this.startY;
      // 你可以在这里添加边界检查，以防止图片拖出容器
    },
    // 停止拖拽，放开鼠标【清除全局监听状态】
    handleMouseUp() {
      console.log(this.position, 20000000000);
      // 移除全局的mousemove和mouseup监听器
      document.removeEventListener("mousemove", this.handleMouseMove);
      document.removeEventListener("mouseup", this.handleMouseUp);
      // 重置拖拽状态
      this.dragging = false;
    },
    // 【移至顶层/移至底层】
    hierarchy(type) {
      console.log(type, 2222222222);
      if (type === "移至顶层" && this.selectedLayerType === "顶图") {
        this.actImgStratum.Base.zIndex = 1; //底
        this.actImgStratum.Top.zIndex = 2; //顶
      }
      if (type === "移至顶层" && this.selectedLayerType === "底图") {
        this.actImgStratum.Base.zIndex = 2; //底
        this.actImgStratum.Top.zIndex = 1; //顶
      }
      if (type === "移至底层" && this.selectedLayerType === "顶图") {
        this.actImgStratum.Base.zIndex = 2; //底
        this.actImgStratum.Top.zIndex = 1; //顶
      }
      if (type === "移至底层" && this.selectedLayerType === "底图") {
        this.actImgStratum.Base.zIndex = 1; //底
        this.actImgStratum.Top.zIndex = 2; //顶
      }
    },
    // 选中图层
    selectedLayer(type) {
      console.log(type, 111111111111111111111);
      this.selectedLayerType = type;
      if (type === "底图") {
        this.actImgStratum.Base.border = true;
        this.actImgStratum.Top.border = false;
      }
      if (type === "顶图") {
        this.actImgStratum.Base.border = false;
        this.actImgStratum.Top.border = true;
      }
    },
    // 上传内容图片
    _handleAvatarSuccess(res, file) {
      this.actImgStratum.Top.url = res.path;
      setTimeout(() => {
        this.imgWidth = this.$refs.dragImg.width;
        this.imgHeight = this.$refs.dragImg.height;
      }, 100);
    },
    // 点击某个item,展示大图
    setSpecification(item) {
      this.actImgStratum.Base.url = item;
    },
    // 上传底图
    handleAvatarSuccess(res, file) {
      this.baseBgList.push(res.path);
      this.actImgStratum.Base.url = res.path;
      console.log(res.path, file, 111000);
    },
    //上传图片的大小校验
    beforeAvatarUpload(file) {
      console.log(file, "filefilefilefile", file.name.indexOf("psd"));
      const isLt5M = file.size / 1024 / 1024 < 5;
      // if (file.name.indexOf('psd') == -1) {
      //   this.$message.error("请上传正确的视频格式");
      //   return false;
      // }
      if (!isLt5M) {
        this.$message.error("上传视频大小不能超过5MB哦!");
        return false;
      }
      // this.handlePsdFile(file)
      this.loadingStatus = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.4)",
        customClass: "fontColor",
      });
    },
    open() {
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style scoped>
.drag-dot {
  width: 8px;
  height: 8px;
  position: absolute;
  bottom: 0;
  right: 0;
  background: aqua;
}
.drag-dot-box {
  width: auto;
  display: inline-block;
  position: relative;
  border: 1px solid aqua;
}
::v-deep .avatar-uploader .el-upload,
.Istyle {
  width: 200px;
  height: 100px;
  display: flex;
  justify-items: center;
  align-items: center;
  /* border: 1px solid aqua; */
}
.Istyle {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.avatar-uploader {
  width: 200px;
  height: 100px;
  display: flex;
  justify-items: center;
  align-items: center;
  /* border: 1px solid red; */
}
.base-map-item img {
  width: 100%;
  height: 100%;
}
.base-map-item {
  width: 200px;
  height: 100px;
  background: #cccccc;
  border: 1px solid #cccccc;
  /* border-radius: 8px;
  overflow: hidden; */
  margin-right: 10px;
}
.base-map-box {
  width: 2000px;
  display: flex;
  align-items: center;
}
.base-map {
  overflow: hidden;
  overflow-x: scroll;
  padding-bottom: 10px;
  box-sizing: border-box;
}
.operation-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 20px auto;
}
.big-base-img {
  width: 375px;
  position: absolute;
  /* top: 0;
  left: 0; */
  cursor: grab; /* 当鼠标悬停在图片上时显示抓取图标 */
  user-select: none; /* 防止选择图片内容 */
}
.set-specification {
  width: 375px;
  height: 600px;
  overflow: hidden;
  overflow-y: scroll;
  background: #cccccc;
  /* border: 1px solid #cccccc; */
  position: relative;
}
.set-specification-box {
  display: flex;
  justify-content: center;
  align-items: center;
}
.box {
  height: 77vh;
  padding: 20px;
  box-sizing: border-box;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  justify-items: center;
  align-items: center;
}
::v-deep .el-dialog {
  margin: 0 auto !important;
}
::-webkit-scrollbar-thumb {
  background: #cccccc; /* 滚动条滑块的颜色 */
  border-radius: 10px; /* 滚动条滑块的圆角 */
}
::-webkit-scrollbar-track {
  background: #fff; /* 滚动条轨道的背景色 */
}
::-webkit-scrollbar {
  width: 1px; /* 滚动条的宽度 */
  height: 1px;
}
</style>
